import { FC, useCallback } from 'react';
import { Autocomplete, Box, Svg, Text, TextField } from '@hopskipdrive/react-components';
import debounce from 'lodash/debounce';

import { DriverSearchResultListItem } from '../../features/InfoNav/DriverDetailsTab/styles';
import { useDriverSearchQuery } from '../../hooks/useDriverSearchQuery';
import { DriverSearchResult } from '../../types/driver';

interface DriverSearchProps {
  setSelectedDriver: (value: DriverSearchResult) => void;
  setAssignDriverModalOpen: (value: boolean) => void;
  setQuery: (value: string) => void;
  query: string;
  setDriverQuery: (value: string) => void;
  driverQuery: string;
}
export const DriverSearch: FC<DriverSearchProps> = ({
  setSelectedDriver,
  setAssignDriverModalOpen,
  setQuery,
  query,
  setDriverQuery,
  driverQuery,
}) => {
  const { data: driversSearchResult, isFetching } = useDriverSearchQuery(driverQuery);
  const debounceQuery = useCallback(
    debounce((value) => {
      if (value) {
        setQuery(value);
        if (value.length >= 3) {
          setDriverQuery(value);
        }
      }
    }, 1000),
    []
  );
  const handleQuerySearch = (value) => {
    debounceQuery(value);
  };

  return (
    <Autocomplete
      freeSolo
      value={query}
      isLoading={isFetching}
      onInputChange={(_, newValue, reason) => {
        if (reason !== 'reset') {
          handleQuerySearch(newValue);
        }
      }}
      handleSelected={(value) => {
        setSelectedDriver(value);
        setAssignDriverModalOpen(true);
      }}
      getOptionLabel={(option) =>
        typeof option === 'string'
          ? option
          : `${option.firstName} ${option.lastName} ${option.region} ${option.slug}` || ''
      }
      renderOption={(props, option) => {
        return (
          <DriverSearchResultListItem {...props}>
            <Text variant="body2" textColor="primaryText">
              {option.firstName} {option.lastName}
            </Text>{' '}
            <Text variant="body2" textColor="secondaryText">
              {option.region} {option.slug}
            </Text>
          </DriverSearchResultListItem>
        );
      }}
      options={driversSearchResult?.data || []}
      renderInput={(params) => (
        <TextField
          {...params}
          fullWidth
          id="driver-search"
          placeholder="Find a Driver"
          variant="outlined"
          size="small"
          InputProps={{
            ...params.InputProps,
            startAdornment: (
              <Box mr={2}>
                <Svg icon="search" />
              </Box>
            ),
          }}
        />
      )}
    />
  );
};
